
export const useFormValidator = () => {
  const required = (value) => (value !== undefined && value !== '' && value !== null) || '入力してください。'
  const requiredIfNeeded = (isNeeded) =>  {
    if (!isNeeded) return true
    return (value) => required(value)
  }
  const requiredMultipleSelectIfNeeded = (isNeeded) => {
    if (!isNeeded) return true
    return (values) => requiredMultipleSelect(values)
  }
  const requiredOtherText = (values) => {
    //その他選択時、自由入力欄にバリデーション
    if(values[0]==='その他') {
      return values[1] !== '' || 'その他を選択した場合は入力してください。'
    }
    //その他以外選択時
    return true;
  }
  const requiredOtherTextMultipleSelectIfNeeded = (selectValues, precondition) => {
    if (!precondition) {
      return
    }
    return requiredOtherTextMultipleSelect(selectValues)
  }
  const requiredOtherTextMultipleSelect = (selectValues) => {
    return (value) => {
      if(Array.from(selectValues).filter(selectValue => selectValue === 'その他').length === 0) {
        return true
      }
      return value.length > 0 || 'その他を選択した場合は入力してください。'
    }
  }
  const requiredMultipleSelect = value => (Array.isArray(value) && value.length > 0) || '必ず選択してください'
  //フリガナ入力バリデーション
  /* eslint no-irregular-whitespace: 0 */
  const kanaText = (value) => value.match(/^[ア-ン゛゜ァ-ォャ-ョー「」、 　]+$/) || '正しく入力してください'
  //暫定対応 ハイフン有 電話番号バリデーション（Door.医師プロフィールに準じて実装）
  const telNumberOfParent = (isNeeded) =>  {
    if (!isNeeded) return true
    return (value) => {
      return value.match(/^0\d{1,3}-\d{2,4}-\d{3,4}$/) || 'ハイフンありで入力してください'
    }
  }
  // const telNumberOfParent = (value) => value.match(/^0\d{1,3}-\d{2,4}-\d{3,4}$/) || 'ハイフンありで入力してください'

  // 体温
  const feverNumber = (isFever, feverNum) => {
    if (!isFever) return true
    if (Number.isInteger(feverNum)) {
      return '体温は整数、もしくは少数で入力してください'
    }
    if (feverNum > 42 || feverNum < 37.5) {
      return '正しい範囲で体温を入力してください'
    }
    return true
  }

  // 診察時刻
  const consultationEndTime = (startTime, endTime) => {
    return Number(endTime.replace(':','')) > Number(startTime.replace(':', ''))
      || '終了時刻は開始時刻より後の時間を入力してください'
  }
  const dateValidate = (selectedDate) =>  {
    const today = new Date();
    const selectDate = new Date(Date.parse(selectedDate));
    return  selectDate <= today
        || '正しい日付を入力してください'
  }

  const dateValidateIfNeeded = (selectDate, precondition) => {
    if (!precondition) {
      return
    }
    return dateValidate(selectDate)
  }

  return {
    required,
    requiredIfNeeded,
    requiredMultipleSelect,
    requiredOtherText,
    requiredOtherTextMultipleSelect,
    requiredMultipleSelectIfNeeded,
    kanaText,
    telNumberOfParent,
    feverNumber,
    consultationEndTime,
    requiredOtherTextMultipleSelectIfNeeded,
    dateValidate,
    dateValidateIfNeeded,
  }
}
